import MapSection from "./MapSection";
import MESSAGES from "../../constants/messages";
import RegistrationSection from "./RegistrationSection";

import "./index.scss";

const Home = () => (
  <>
    <div className="registration-open-banner">
      <p>{MESSAGES.REGISTRATION_OPEN_NOTICE}</p>
    </div>
    <RegistrationSection />
    <MapSection />
  </>
);

export default Home
